import React, { memo } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { LazyLoadImage as ProductCompanyLogo } from 'react-lazy-load-image-component';
import PropTypes from 'prop-types';

import { grayBlock } from '@/assets/img';
import { getGtmEvents, getLocaleUrlPath, getOrganizationUrl } from '@/utils';

import CardRating from './CardRating';
import {
  DescriptionTooltip,
  LinkTooltip,
  ProductCompanyInfo,
  ProductCompanyLicense,
  ProductCompanyLogoBtn,
  ProductCompanyRating,
  TitleTooltip,
} from './CompanyInfo.styles';

function CompanyInfo({
  companySlug,
  logoUrl = '',
  companyName,
  companyLicense = null,
  companyRating = '0',
  isFlatContent = false,
}) {
  const { locale } = useIntl();

  return (
    <ProductCompanyInfo $isFlatContent={isFlatContent}>
      <ProductCompanyLogoBtn
        $isFlatContent={isFlatContent}
        to={getOrganizationUrl(companySlug)}
      >
        <ProductCompanyLogo
          placeholderSrc={grayBlock}
          visibleByDefault={logoUrl === grayBlock}
          effect="opacity"
          alt={companyName}
          title={companyName}
          width="auto"
          height="48"
          src={logoUrl}
          {...getGtmEvents({
            gtmEl: `${companySlug}`,
            gtmEa: 'toggle-logo',
            gtmEaName: 'credits_toggle-logo',
          })}
        />
      </ProductCompanyLogoBtn>

      <ProductCompanyRating $isFlatContent={isFlatContent}>
        {!!companyRating && (
          <CardRating position="top" rating={companyRating}>
            <div>
              <TitleTooltip>
                <FormattedMessage
                  id="rating.tooltipTitle.bank"
                  values={{ companyRating }}
                />
              </TitleTooltip>

              <DescriptionTooltip>
                <FormattedMessage id="rating.tooltip.bank" />
              </DescriptionTooltip>

              <LinkTooltip
                href={`https://minfin.com.ua${getLocaleUrlPath(
                  locale
                )}/banks/rating/`}
                title=""
                target="_blank"
              >
                <FormattedMessage id="productCard.moreButton" />
              </LinkTooltip>
            </div>
          </CardRating>
        )}

        {companyLicense && (
          <ProductCompanyLicense>{companyLicense}</ProductCompanyLicense>
        )}
      </ProductCompanyRating>
    </ProductCompanyInfo>
  );
}

CompanyInfo.propTypes = {
  companySlug: PropTypes.string.isRequired,
  logoUrl: PropTypes.string,
  companyName: PropTypes.string.isRequired,
  companyLicense: PropTypes.string,
  companyRating: PropTypes.string,
  isFlatContent: PropTypes.bool,
};

export default memo(CompanyInfo);
